import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})

export class ToastService  {
  constructor(public toaster: ToastrService) {
  }

 

  showToastInfo(message: string, title: string, timeout: number) {
    this.toaster.info(message, title, {timeOut: timeout});
}

  showToastWarning(message: string, title: string, timeout: number) {
    this.toaster.warning(message, title, {timeOut: timeout});
}

  showToastError(message: string, title: string, timeout: number) {
    this.toaster.error(message, title, {timeOut: timeout, enableHtml: true});
}

}
